import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './components/app';
import './index.scss';
import 'cbs-layout-wrapper/dist/style.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
export { DangerButton } from './components/danger-button/danger-button';
export { PromoPanelTitle } from './components/promo-panel/promo-panel-title';
export { PromoPanelRow } from './components/promo-panel/promo-panel-row';
